import { render, staticRenderFns } from "./DeliveredNotInvoiced.vue?vue&type=template&id=6ffde936&scoped=true"
import script from "./DeliveredNotInvoiced.vue?vue&type=script&lang=js"
export * from "./DeliveredNotInvoiced.vue?vue&type=script&lang=js"
import style0 from "./DeliveredNotInvoiced.vue?vue&type=style&index=0&id=6ffde936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffde936",
  null
  
)

export default component.exports